export const environment = {
	production: false,
	dev: true,
	consoleLogAnalytics: true,
	isEmea: false,
	apiUrl: "https://dealer-api-dev-2025.control4.com/",
	secondaryApiUrl: "https://dealer-emea-api-dev-2025.control4.com/",
	secondaryPortalUrl: "https://dealer-emea-dev-2025.control4.com",
	technicianPortalUrl: "https://fullsandb-c4technician.cs96.force.com/technician/s/",
	postForwarderUrl: "https://www-dev.control4.com/assets/scripts/post-forwarder.php",
	trackingCode: "UA-69905-1",
	// Browser-only Maps JS key. Replace with a referrer-restricted key that is
	// NOT shared with the server-side geocoding key, then rotate the old key.
	googleMapsBrowserKey: "AIzaSyCACzdZyu-EG4W-k_nHZeDm2ZEa8PsuWUg",
	lmsportal: "https://lmssandbox.learnupon.com/lpaths/",
	salesForceChatEnv: "DealerControl4",
	salesForceChatJsPath: 'https://control4--fullsandb.sandbox.my.site.com/ESWDealerControl41767805699051/assets/js/bootstrap.min.js',
	salesForceChatId: '00DTI000000JKFx',
	salesForceChatUrl: 'https://control4--fullsandb.sandbox.my.site.com/ESWDealerControl41767805699051',
	salesForceChatScrtUrl: 'https://control4--fullsandb.sandbox.my.salesforce-scrt.com',
	forumTechCommunityUrl: "https://control4--fullsandb.sandbox.my.site.com/technician/SSORedirectpage?portal=dealer&startURL=%2Fs%2Fdiscussionsv2",
	NiceChatLoaderUrl: 'https://web-modules-de-na1.niceincontact.com/loader/1/loader.js',
    NiceChatTENANTID: '5761',
	NiceChatStartHour: 9,
	NiceChatStartMinute: 0,
	NiceChatEndHour: 20,
	NiceChatEndMinute: 0
};
